import { Component, Input, OnInit, inject } from "@angular/core";

import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { MatStepperModule } from "@angular/material/stepper";
import { DialogoLeerAyudasComponent } from "./dialogo-leer-ayudas/dialogo-leer-ayudas.component";
import { MatDialog } from "@angular/material/dialog";
import { DatabaseService } from "src/app/servicios/database/database.service";
import { PermissionsService } from "src/app/servicios/permissions/permissions.service";
import { MessageService } from "src/app/servicios/message/message.service";

@Component({
  selector: "app-consultar-ayuda",
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    SweetAlert2Module,
    TranslateModule,
    MatStepperModule,
    TranslateModule,
],
  templateUrl: "./consultar-ayuda.component.html",
  styleUrls: ["./consultar-ayuda.component.scss"],
})
export class ConsultarAyudaComponent implements OnInit {
  private dialogService = inject(MatDialog);
  private permissionService = inject(PermissionsService);
  private databaseService = inject(DatabaseService);
  private messageService = inject(MessageService);
  private translateService = inject(TranslateService);

  @Input() submodulo;
  @Input() icon = "help";

  ayudas = [];

  variables;

  ngOnInit(): void {
    this.translateService
      .get(["submodulo-sin-ayudas"])
      .subscribe((translation) => (this.variables = translation));
  }

  /**
   * Abre un Sweetalert con todas las alertas disponibles para el módulo
   */
  consultarAyuda() {
    const loadingSnack = this.messageService.snackBarMessage('cargando-ayudas-pantalla', 'Ok', {
      horizontalPosition: 'left',
      verticalPosition: 'bottom'
    });

    this.databaseService
      .consultarAyudasSubmodulo(this.permissionService.getActiveRouteId())
      .subscribe((ayudas: any) => {
        this.ayudas = Object.values(ayudas);
        
        loadingSnack.dismiss();

        if (this.ayudas.length === 0) {
          this.messageService.SwalMessage(
            "info",
            this.variables["submodulo-sin-ayudas"],
            false,
            2000
          );
          return;
        }

        this.dialogService.open(DialogoLeerAyudasComponent, {
          width: "75%",
          maxWidth: "100vw",
          height: "80%",
          autoFocus: false,
          panelClass: [
            "unset-mat-content-height",
            "mat-dialog-container-stock",
          ],
          data: {
            pages: this.ayudas,
            length: this.ayudas.length
          },
        });
      });
  }
}
